/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
// Dependencias
import React, { Component } from 'react';
/* global $ */

// Hojas de Estilos
import './Table.scss';

class TableEvaluaciones extends Component {
  componentDidMount() {
    $('.tblEvaluaciones a.file-clock').popover({
      content: 'En proceso de actualización y/o ajuste',
      placement: 'left',
      trigger: 'focus hover',
    });
  }

  render() {
    const { items } = this.props;
    return (
      <div className="tblEvaluaciones">
        <table className="tbl">
          <tbody>
            {
                        items.map((item, index) => {
                          switch (item.type) {
                            case 'file':
                              return (
                                <tr key={index}>
                                  <td className="item-title">{item.title}</td>
                                  <td className="cell-enlaces">
                                    {
                                                    (item.xlsLink !== '' || item.pdfLink !== '')
                                                      ? (item.xlsLink === '' && item.pdfLink !== '') ? (
                                                        <div className="item-enlace single-btn">
                                                          <a className="file-clock" tabIndex="0">
                                                            <i className="fas fa-clock" />
                                                          </a>
                                                        </div>
                                                      ) : (
                                                        <div className="item-enlace single-btn">
                                                          <a href={item.xlsLink} className="file-xls">XLS</a>
                                                        </div>
                                                      ) : null
                                                }
                                    {
                                                    (item.xlsLink !== '' || item.pdfLink !== '')
                                                      ? (item.xlsLink !== '' && item.pdfLink === '') ? (
                                                        <div className="item-enlace single-btn">
                                                          <a className="file-clock" tabIndex="0">
                                                            <i className="fas fa-clock" />
                                                          </a>
                                                        </div>
                                                      ) : (
                                                        <div className="item-enlace single-btn">
                                                          <a href={item.pdfLink} className="file-pdf">PDF</a>
                                                        </div>
                                                      ) : null
                                                }
                                    {
                                                    (item.xlsLink === '' && item.pdfLink === '') ? (
                                                      <div className="item-enlace whole-width">
                                                        <a className="file-clock" tabIndex="0">
                                                          <i className="fas fa-clock" />
                                                        </a>
                                                      </div>
                                                    ) : null
                                                }
                                  </td>
                                </tr>
                              );
                            case 'pdf':
                            case 'xls':
                              return (
                                <tr key={index}>
                                  <td className="item-title">{item.title}</td>
                                  <td className="cell-enlaces">
                                    {
                                                    (item.link === '') ? (
                                                      <div className="item-enlace">
                                                        <a className="file-clock" tabIndex="0"><i className="fas fa-clock" /></a>
                                                      </div>
                                                    ) : (
                                                      <div className="item-enlace">
                                                        <a href={item.link} target="_blank" rel="noopener noreferrer" className={`file-${item.type}`}>{item.type}</a>
                                                      </div>
                                                    )
                                                }
                                  </td>
                                </tr>
                              );
                            default:
                              return (
                                <tr key={index}>
                                  <td className="item-title">{item.title}</td>
                                  <td className="cell-enlaces">
                                    {
                                                    (item.link === '') ? (
                                                      <div className="item-enlace">
                                                        <a className="file-clock" tabIndex="0"><i className="fas fa-clock" /></a>
                                                      </div>
                                                    ) : (
                                                      <div className="item-enlace">
                                                        <a href={item.link} target="_blank" rel="noopener noreferrer" className="external-link"><i className="fas fa-external-link-alt" /></a>
                                                      </div>
                                                    )
                                                }
                                  </td>
                                </tr>
                              );
                          }
                        })
                    }
          </tbody>
        </table>
      </div>
    );
  }
}

export default TableEvaluaciones;
